import gql from 'graphql-tag';

export interface AdminRemovePlusOneGuestInput {
  eventId: number;
  gid: string;
  plusOneId: number;
}

export interface AdminRemovePlusOneGuestVariables {
  input: AdminRemovePlusOneGuestInput;
}

export interface AdminRemovePlusOneGuestResponse {
  adminRemovePlusOneGuest: {
    ok: boolean;
  };
}

export const ADMIN_REMOVE_PLUS_ONE_GUEST_MUTATION = gql`
  mutation adminRemovePlusOneGuest($input: AdminRemovePlusOneGuestInput!) {
    adminRemovePlusOneGuest(input: $input) {
      ok
    }
  }
`;
